import React, { useEffect, useContext, useState } from 'react';
import { Menu, useSidebarState } from 'react-admin';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import SearchIcon from '@mui/icons-material/Search';
import { Box, Button, Typography, Badge, useMediaQuery, InputBase } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ApiService from '../../functions/apiService';
import {
  HomeIcon,
  SchedulingIcon,
  MemberIcon,
  AvailabilityIcon,
  InventoryMenuIcon,
  NERISIcon,
  ConfigIcon,
  PayrollMenuIcon,
  ReportsMenuIcon,
  MessageIcon,
  ShiftCallsIcon,
  PayrollIcon

} from './Svg';
import AuthContext from '../../context/AuthContext';
import { useSelector } from 'react-redux';
import Collapse from '@mui/material/Collapse';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { containsPartFromArray } from '../../functions/helper';
import { MenuItemLink } from 'react-admin';
import MenuBadge from './MenuBadge';

export const MyMenu = () => {
  const [open, setOpen] = useSidebarState(true);
  const { permission, pages, v3Data, pagesName, approveRtoCount , user } = useContext(AuthContext);
  const [department, setDepartment] = useState('');
  const [name, setName] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();
  const [notificationLength, setNotificationLength] = useState([]);
  const [maintenanceLink, setMaintenanceLink] = useState('');
  const isMobile = useMediaQuery('(max-width: 667px)');
  const isIPad = useMediaQuery('(min-width: 768px) and (max-width: 1024px)');

  const closedMenus = {
    scheduling: false,
    memberManagement: false,
    availability: false,
    inventory: false,
    NERIS: false,
    Payroll: false,
    Settings: false,
    Reports: false,
    Messages: false,
    VolunteerReports: false,
  };

  const [menuOpen, setMenuOpen] = useState(closedMenus);

  const menuRowStyles = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: open ? 'space-between' : 'center',
    cursor: 'pointer',
    color: '#fff',
    px: open ? 2 : 1,
    py: 0,
    mx: open ? 2 : 0,
    borderRadius: '8px',
    height: '2.5rem',
    fontFamily: 'karla, sans-serif',
    fontSize: '0.9375rem',
    fontWeight: 600,
    '&:hover': { backgroundColor: '#2E3238' },
  };

  const subMenuRowStyles = {
    ...menuRowStyles,
    fontSize: '0.875rem',
    fontWeight: 400,
    height: '2.25rem',
  };


  const forceWhiteMenuItem = {
    color: '#fff !important',
    '& svg, & span': { color: '#fff' },
    '&:hover, &:focus, &:active': { color: '#fff' },
  };

  // const toggleMenu = (key) => {
  //   setMenuOpen((prev) => ({ ...prev, [key]: !prev[key] }));
  // };
  const { permissions } = useSelector(
    (state) => state.nerisSettingsAuthoritiesReducer
  );

  let groupName = Object.keys(pagesName).includes("GROUP_HEADER_TEXT")
    ? pagesName.GROUP_HEADER_TEXT
    : "Group";

  useEffect(() => {
    let content = document.querySelector('#main-content');
    if (content) {
      if (open) {
        document.querySelector('#main-content').style.width =
          'calc(100vw - 280px)';
      } else {
        document.querySelector('#main-content').style.width =
          'calc(100vw - 72px)';
      }
    }
  }, [open]);

  useEffect(() => {
    const storedDepartment = localStorage.getItem('department');
    const storedName = localStorage.getItem('user');
    if (storedDepartment) {
      setDepartment(storedDepartment);
    }

    if (storedName) {
      const userName = JSON.parse(storedName);
      setName(userName.fullName);
    }
  }, []);

  useEffect(() => {
    if (!open) {
      setMenuOpen(closedMenus);
      setSearchQuery('');
    }
  }, [open]);

  const toggleMenu = (key) => {
    if (!open) {
      setOpen(true);
    }

    setMenuOpen((prev) => {
      const newState = Object.keys(prev).reduce((acc, k) => {
        acc[k] = false;
        return acc;
      }, {});

      newState[key] = !prev[key];
      return newState;
    });
  };

  const allMenuItems = [
    { label: 'Home', to: '/firehouse/calendar', hidden: false },
    // Scheduling
    { label: 'Calendar', to: '/firehouse/calendar', hidden: false },
    { label: 'Schedule', to: '/firehouse/schedule', hidden: false },
    { label: 'My Shifts', to: '/firehouse/my-shifts', hidden: false },
    { label: 'My Team', to: '/firehouse/my-team', hidden: false },
    { label: 'Accept Shifts', to: '/firehouse/accept-shifts', hidden: false },
    { label: pagesName?.MENU_TEXT_FILL_SHIFTS || 'Fill Shifts', to: '/firehouse/fill-shift', hidden: pages.includes('V3_NEW_FILL_STRUCTURE') || !containsPartFromArray(permission, 'OT_Auth') },
    { label: 'Fill Positions', to: '/firehouse/fill-positions', hidden: !pages.includes('V3_POSITION_ASSIGNMENT_FILLABLE') || !containsPartFromArray(permission, 'OT_Auth') },
    { label: 'Shift Calls', to: '/firehouse/shift-calls', hidden: !(permission.includes('Emp_Auth') || permission.includes('master_user')) || !pages.includes('V3_NEW_FILL_STRUCTURE') },
    { label: 'My Shift Calls', to: '/firehouse/my-shift-calls', hidden: !pages.includes('V3_NEW_FILL_STRUCTURE') },
    { label: pagesName?.MENU_TEXT_CALLBACKS || 'Call Backs', to: '/firehouse/callback', hidden: v3Data?.V3_SIDEBAR_CALLBACK_MENU !== 'true' },
    { label: 'Watch Party', to: '/firehouse/watch-party', hidden: !pages.includes('MENU_WATCH_PARTY') },
    { label: 'Details', to: '/firehouse/details', hidden: !permission.includes('Schedule_Auth') },
    { label: 'Overtime Signup', to: '/firehouse/overtime-signup', hidden: !pages.includes('V3_OVERTIME_SIGNUP_FORM') },
    { label: 'Position Assignment', to: '/firehouse/position-assignment', hidden: !(permission.includes('Emp_Auth') && pages.includes('V3_Volunteer_Signup')) },
    { label: 'Assignment Requests', to: '/firehouse/assignment-requests', hidden: !(permission.includes('Emp_Auth') && pages.includes('V3_Volunteer_Signup')) },
    { label: 'Cancelled Assignments', to: '/firehouse/cancelled-assignments', hidden: !(permission.includes('Emp_Auth') && pages.includes('V3_Volunteer_Signup')) },
    { label: 'Resource Assignment', to: '/firehouse/schedule-override', hidden: !(permission.includes('Emp_Auth') || permission.includes('master_user')) || !pages.includes('SCHEDULE_SELECT_POSITION_DAY_NIGHT') },
    { label: 'Recall/Pages', to: '/firehouse/recall/pages', hidden: !v3Data?.V3_recall_menu || !permission.includes('GR_Auth') },
    { label: 'User Recall', to: '/firehouse/user-recall', hidden: !v3Data?.V3_recall_menu || permission.includes('Emp_Auth') || permission.includes('master_user') },
    { label: 'Import Schedule', to: '/firehouse/import-schedule', hidden: !v3Data?.IMPORT_SCHEDULE || !permission.includes('Emp_Auth') || !permission.includes('master_user') },
    { label: 'Daily Swap List', to: '/firehouse/daily-swap-list', hidden: !v3Data?.V3_dailyswap_adjustment },
    // Personnel
    { label: 'Members', to: '/firehouse/members', hidden: !permission.includes('Emp_Auth') || !permission.includes('OT_Auth') },
    { label: 'Approve RTO', to: '/firehouse/approve-shifts', hidden: !permission.includes('Emp_Auth') || !containsPartFromArray(permission, 'OT_Auth,OT_APPROVE') },
    { label: 'Swap Requests', to: '/firehouse/manage-swap-requests', hidden: !(permission.includes('Emp_Auth') && v3Data?.V3_SHIFT_TRADE_ENABLED == 'true') },
    { label: 'Lists', to: '/firehouse/Lists', hidden: false },
    { label: 'Manage Overtime', to: '/firehouse/manage-overtime', hidden: !(permission.includes('Emp_Auth') && permission.includes('OT_Auth')) },
    { label: 'Adjust Hours', to: '/firehouse/adjust-hours', hidden: !(permission.includes('Emp_Auth') && permission.includes('OT_Auth')) },
    { label: 'Manage Passes', to: '/firehouse/manage-free-passes', hidden: !v3Data?.V3_ENABLE_MANAGE_OS_PASSES || !containsPartFromArray(permission, 'OT_Auth,OT_APPROVE') },
    { label: 'Certificates', to: '/firehouse/certificates', hidden: !pages.includes('V3_CERTIFICATE_MODULE') || !permission.includes('Emp_Auth') },
    // Availability
    { label: 'Request RTO', to: '/firehouse/RTO', hidden: !pages.includes('MENU_REQ_TIME_OFF') },
    { label: 'Leave Book', to: '/firehouse/leave-book', hidden: !pages.includes('MENU_LEAVE_BOOK') },
    { label: v3Data?.V3_VERBIAGE_VOLUNTEER ? 'Per-diem Signup' : 'Volunteer Signup', to: '/firehouse/volunteer-signup-new', hidden: !pages.includes('V3_Volunteer_Signup') },
    { label: 'Vacation Bids', to: '/firehouse/vacation-bids', hidden: !v3Data?.V3_VACATION_BIDDING || !permission.includes('Emp_Auth') },
    { label: 'My Vacation Bids', to: '/firehouse/vacation-bid-user', hidden: !v3Data?.V3_VACATION_BIDDING },
    { label: 'View Bids', to: '/firehouse/view-bids', hidden: !pages.includes('VIEWBIDS') || !permission.includes('Schedule_Auth') },
    { label: 'Off Duty Training', to: '/firehouse/off-duty-training', hidden: !v3Data?.V3_OFF_DUTY_TRAINING_MODULE },
    // Inventory
    { label: 'My Tickets', to: '/firehouse/tickets', hidden: !pages.includes('V3_INVENTORY_MODULE') },
    { label: 'Checklist Definition', to: '/firehouse/checklist', hidden: !pages.includes('V3_INVENTORY_MODULE') || !permission.includes('Schedule_Auth') },
    { label: 'Station Checklist', to: '/firehouse/station-checklist', hidden: !pages.includes('V3_INVENTORY_MODULE') || !permission.includes('Schedule_Auth') },
    { label: 'Daily Check View', to: '/firehouse/checklist-chief/data', hidden: !pages.includes('V3_INVENTORY_MODULE') || !permission.includes('Schedule_Auth') },
    { label: 'My Checklist', to: '/firehouse/my-checklist', hidden: !pages.includes('V3_INVENTORY_MODULE') },
    { label: 'My Station Checklist', to: '/firehouse/my-station-checklist', hidden: !pages.includes('V3_INVENTORY_MODULE') },
    { label: 'Attributes', to: '/firehouse/attribute-management', hidden: !pages.includes('V3_INVENTORY_MODULE') || !permission.includes('Schedule_Auth') },
    { label: 'Inventory Management', to: '/firehouse/inventory', hidden: !pages.includes('V3_INVENTORY_MODULE') || !permission.includes('Schedule_Auth') },
    // NERIS
    { label: 'Incidents', to: '/firehouse/incidents', hidden: !pages.includes('V3_NERIS_MODULE') },
    { label: 'Pre-Plans', to: '/firehouse/pre-plans', hidden: !pages.includes('V3_NERIS_MODULE') || !permission.includes('Schedule_Auth') },
    { label: 'Inspections', to: '/firehouse/inspections', hidden: !pages.includes('V3_NERIS_MODULE') || !permission.includes('Schedule_Auth') },
    { label: 'NERIS Settings', to: '/firehouse/neris-settings', hidden: !pages.includes('V3_NERIS_MODULE') },
    // Payroll
    { label: 'Submitted Payroll', to: '/firehouse/personal-payroll-report', hidden: !v3Data?.V3_PERSONAL_PAYROLL_ACK },
    { label: 'Payroll Management', to: '/firehouse/payroll', hidden: !permission.includes('Schedule_Auth') },
    // Top-level
    { label: 'Volunteer Reports', to: '/firehouse/volunteer-report', hidden: !v3Data?.V3_VOLUNTEER_REPORT_VIEW_ALL },
    { label: 'Volunteer Open Shift', to: '/firehouse/volunteer-open-shift', hidden: !v3Data?.V3_VOLUNTEER_OPEN_SHIFT_REPORT },
    { label: 'Volunteer Member Hours', to: '/firehouse/volunteer-member-hours', hidden: !v3Data?.V3_VOLUNTEER_MEMBER_HOURS_REPORT },
    { label: 'Reports', to: '/firehouse/reports', hidden: !permission.includes('Schedule_Auth') },
    { label: 'JAKE Data Analysis', to: '/firehouse/jake-data-analysis', hidden: false },
    { label: 'Messages', to: v3Data?.V3_NEW_MESSAGE_MODULE ? '/firehouse/chats' : '/firehouse/messaging', hidden: !v3Data?.V3_NEW_MESSAGE_MODULE && !permission.includes('SMS_Auth') },
    { label: 'Custom Group', to: '/firehouse/custom-groups', hidden: v3Data?.V3_NEW_MESSAGE_MODULE || !permission.includes('SMS_Auth') },
    // Settings
    { label: 'System Log', to: '/firehouse/view-log', hidden: !permission.includes('Emp_Auth') },
    { label: 'System Variables', to: '/firehouse/config', hidden: !permission.includes('Emp_Auth') || !permission.includes('global_admin') },
    { label: 'System Tools', to: '/firehouse/admin-panel', hidden: !permission.includes('Emp_Auth') || !permission.includes('global_admin') },
    { label: 'Journals', to: '/firehouse/audit-log', hidden: !permission.includes('Emp_Auth') || !permission.includes('Schedule_Auth') },
    { label: 'Static Data', to: '/firehouse/select-option', hidden: !permission.includes('global_admin') && (!v3Data?.V3_ALLOW_SYSTEM_OPTIONS_PAGE || !pages.includes('SystemOptions'))},
    { label: 'Groups', to: '/firehouse/groups-settings', hidden: !permission.includes('Emp_Auth') || !permission.includes('global_admin') },
    { label: 'Templates', to: '/firehouse/template/management', hidden: !permission.includes('Emp_Auth') || !permission.includes('Schedule_Auth') },
  ];

  // const loadNotificationsCount = () => {
  //   ApiService.get('/notificationsHeader')
  //     .then(({ data }) => {
  //       setNotificationLength(data?.data);
  //       setPendingCount(data?.approve_rto)
  //     })
  //     .catch((err) => {
  //       console.error(err);
  //     });
  // };

  // useEffect(() => {
  //   loadNotificationsCount();
  // }, []);
  // console.log("pendingCount====>146",,approveRtoCount)
  return (
    <>
      <Menu
        sx={{
          margin: 0,
          background:
            'radial-gradient(circle at 0%  ,#5362EBd1 -80%,#1E1E1E 40%)',
          backgroundPostion: 'left',
          height: '100vh',
          color: '#fff',
        }}
      >

        {isMobile && (<Box
          sx={{
            display: 'flex',
            justifyContent: open ? 'space-between' : 'center',
            // height: '110px',
          }}
        >
          <img
            className="ms-3 my-3"
            src="/images/LogoColor.svg"
            style={{
              display: open ? 'block' : 'none',
              width: 'auto',
              height: '44px'
            }}
          />
          <div className="mt-4" style={{ display: open ? 'block' : 'none' }}>
            {/* <Badge
              badgeContent={notificationLength}
              sx={{
                '& .MuiBadge-badge': {
                  backgroundColor: '#F5F5F5',
                  color: '#2E3238',
                  marginRight: '3px',
                  marginTop: '3px',
                },
              }}
            >
              <div onClick={handleClick} className="notification-icon">
                <img src="/images/notification.svg" />
              </div>
            </Badge> */}
          </div>
          <Button
            sx={{
              color: '#FFF',
              height: '74px',
              width: '74px',
              '&.MuiButton-root:active': { backgroundColor: '#2E3238' },
              '&.MuiButton-root:hover': { backgroundColor: 'transparent' },
            }}
            onClick={() => setOpen(!open)}
            endIcon={
              open ? (
                <KeyboardDoubleArrowLeftIcon style={{ fontSize: 30 }} />
              ) : (
                <KeyboardDoubleArrowRightIcon style={{ fontSize: 30 }} />
              )
            }
          ></Button>
        </Box>)}

        <Box sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          height: '100vh'
        }}>
          <Box
            className="menu-scroll-css"
            sx={{
              height: isIPad ? '34vh' : ' 70vh',
              position: 'sticky',
              overflow: 'scroll',
            }}
          >

            {open && (
              <Box sx={{ px: 2, pt: 1, pb: 0.5, position: 'sticky', top: 0, zIndex: 1, backgroundColor: '#1E1E1E' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', backgroundColor: '#2E3238', borderRadius: '8px', px: 1.5, height: '2.25rem' }}>
                  <SearchIcon sx={{ color: 'rgba(255,255,255,0.4)', fontSize: 17, mr: 1 }} />
                  <InputBase
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    placeholder="Search menu..."
                    sx={{ color: '#fff', fontSize: '0.875rem', flex: 1, fontFamily: 'karla, sans-serif' }}
                  />
                </Box>
              </Box>
            )}

            {searchQuery ? (
              <Box sx={{ px: open ? 1 : 0 }}>
                {allMenuItems
                  .filter(item => !item.hidden && item.label.toLowerCase().includes(searchQuery.toLowerCase()))
                  .map((item, i) => (
                    <Menu.Item
                      key={i}
                      to={item.to}
                      primaryText={item.label}
                      sx={{
                        ...subMenuRowStyles,
                        '&.RaMenuItemLink-active': { color: '#ABABAB', backgroundColor: '#2E3238' },
                      }}
                    />
                  ))}
                {allMenuItems.filter(item => !item.hidden && item.label.toLowerCase().includes(searchQuery.toLowerCase())).length === 0 && (
                  <Box sx={{ color: 'rgba(255,255,255,0.4)', fontSize: '0.875rem', px: 2, py: 2, fontFamily: 'karla, sans-serif' }}>No results found</Box>
                )}
              </Box>
            ) : (<>

            <Menu.Item
              to="/firehouse/calendar"
              sx={{
                ...menuRowStyles,
                height: '2.5rem',
                '&.RaMenuItemLink-active': {
                  color: '#ABABAB',
                  backgroundColor: '#2E3238',
                },
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <ReportsMenuIcon width="20px" height="20px" />
                {open && <span style={{ marginLeft: '0.625rem', fontFamily: 'karla, sans-serif', fontSize: '0.9375rem', fontWeight: 600 }}>Home</span>}
              </Box>
            </Menu.Item>

            <Box onClick={() => toggleMenu('scheduling')} sx={menuRowStyles}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <SchedulingIcon width="20px" height="20px" />
                {open && <span style={{ marginLeft: '0.625rem', fontFamily: 'karla, sans-serif', fontSize: '0.9375rem', fontWeight: 600 }}>Scheduling</span>}
              </Box>

              {open &&
                (menuOpen.scheduling ? (
                  <KeyboardArrowDownIcon />
                ) : (
                  <KeyboardArrowRightIcon />
                ))}
            </Box>

            <Collapse in={menuOpen.scheduling} timeout={1000} unmountOnExit>
              <Box sx={{ ml: open ? 4 : 0, borderLeft: open ? "2px solid rgba(255,255,255,0.15)" : "none", pl: open ? 1 : 0 }}>
                <Menu.Item
                  to="/firehouse/calendar"
                  primaryText="Calender"
                  sx={{
                    ...subMenuRowStyles,
                    pl: open ? 6 : 1,
                    '&.RaMenuItemLink-active': {
                      color: '#ABABAB',
                      backgroundColor: '#2E3238',
                    },
                  }}
                />

                <Menu.Item
                  to="/firehouse/schedule"
                  primaryText="Schedule"
                  sx={{
                    ...subMenuRowStyles,
                    pl: open ? 6 : 1,
                    '&.RaMenuItemLink-active': {
                      color: '#ABABAB',
                      backgroundColor: '#2E3238',
                    },
                  }}
                />

                <Menu.Item
                  to="/firehouse/my-shifts"
                  primaryText="My Shifts"
                  sx={{
                    ...subMenuRowStyles,
                    pl: open ? 6 : 1,
                    '&.RaMenuItemLink-active': {
                      color: '#ABABAB',
                      backgroundColor: '#2E3238',
                    },
                  }}
                />

                <Menu.Item
                  to="/firehouse/my-team"
                  primaryText="My Team"
                  // hidden={!permission.includes('Emp_Auth')}
                  sx={{
                    ...subMenuRowStyles,
                    pl: open ? 6 : 1,
                    '&.RaMenuItemLink-active': {
                      color: '#ABABAB',
                      backgroundColor: '#2E3238',
                    },
                  }}
                />

                <Menu.Item
                  to="/firehouse/accept-shifts"
                  primaryText="Accept Shifts"
                  sx={{
                    ...subMenuRowStyles,
                    pl: open ? 6 : 1,
                    '&.RaMenuItemLink-active': {
                      color: '#ABABAB',
                      backgroundColor: '#2E3238',
                    },
                  }}
                />

                <Menu.Item
                  to="/firehouse/fill-shift"
                  primaryText={Object.keys(pagesName).includes("MENU_TEXT_FILL_SHIFTS") ? pagesName.MENU_TEXT_FILL_SHIFTS : "Fill Shifts"}
                  hidden={(pages.includes("V3_NEW_FILL_STRUCTURE") || !containsPartFromArray(permission, "OT_Auth"))}
                  sx={{
                    ...subMenuRowStyles,
                    pl: open ? 6 : 1,
                    '&.RaMenuItemLink-active': {
                      color: '#ABABAB',
                      backgroundColor: '#2E3238',
                    },
                  }}
                />

                {/* <Menu.Item
                  to="#"
                  primaryText="Bird Dogs"
                  sx={{
                    ...subMenuRowStyles,
                    pl: open ? 6 : 1,
                    '&.RaMenuItemLink-active': {
                      color: '#ABABAB',
                      backgroundColor: '#2E3238',
                    },
                  }}
                /> */}

                <Menu.Item
                  to="/firehouse/fill-positions"
                  primaryText="Fill Positions"
                  hidden={(!pages.includes("V3_POSITION_ASSIGNMENT_FILLABLE") || !containsPartFromArray(permission, "OT_Auth"))}
                  sx={{
                    ...subMenuRowStyles,
                    pl: open ? 6 : 1,
                    '&.RaMenuItemLink-active': {
                      color: '#ABABAB',
                      backgroundColor: '#2E3238',
                    },
                  }}
                />

                {(permission.includes('Emp_Auth') || permission.includes('master_user')) && <Menu.Item
                  to="/firehouse/shift-calls"
                  primaryText="  Shift Calls"
                  hidden={!pages.includes('V3_NEW_FILL_STRUCTURE')}
                  sx={{
                    ...subMenuRowStyles,
                    pl: open ? 6 : 1,
                    '&.RaMenuItemLink-active': {
                      color: '#ABABAB',
                      backgroundColor: '#2E3238',
                    },
                  }}
                />}
                <Menu.Item
                  sx={{
                    ...subMenuRowStyles,
                    pl: open ? 6 : 1,
                    '&.RaMenuItemLink-active': {
                      color: '#ABABAB',
                      backgroundColor: '#2E3238',
                    },
                  }}
                  to="/firehouse/my-shift-calls"
                  primaryText="My Shift Calls"
                  hidden={!pages.includes('V3_NEW_FILL_STRUCTURE')}
                />

                {v3Data?.V3_SIDEBAR_CALLBACK_MENU === 'true' && <Menu.Item
                  to="/firehouse/callback"
                  primaryText={Object.keys(pagesName).includes("MENU_TEXT_CALLBACKS") ? pagesName.MENU_TEXT_CALLBACKS : "Call Backs"}
                  sx={{
                    ...subMenuRowStyles,
                    pl: open ? 6 : 1,
                    '&.RaMenuItemLink-active': {
                      color: '#ABABAB',
                      backgroundColor: '#2E3238',
                    },
                  }}
                />}

                <Menu.Item
                  to="/firehouse/watch-party"
                  primaryText="Watch Party"
                  hidden={!pages.includes('MENU_WATCH_PARTY')}
                  sx={{
                    ...subMenuRowStyles,
                    pl: open ? 6 : 1,
                    '&.RaMenuItemLink-active': {
                      color: '#ABABAB',
                      backgroundColor: '#2E3238',
                    },
                  }}
                />

                <Menu.Item
                  to="/firehouse/details"
                  primaryText="Details"
                  hidden={!permission.includes("Schedule_Auth")}
                  sx={{
                    ...subMenuRowStyles,
                    pl: open ? 6 : 1,
                    '&.RaMenuItemLink-active': {
                      color: '#ABABAB',
                      backgroundColor: '#2E3238',
                    },
                  }}
                />

                <Menu.Item
                  to="/firehouse/position-assignment"
                  primaryText="Position Assignment"
                  hidden={permission.includes('Emp_Auth') && pages.includes('V3_Volunteer_Signup') ? false : true}
                  sx={{
                    ...subMenuRowStyles,
                    pl: open ? 6 : 1,
                    '&.RaMenuItemLink-active': {
                      color: '#ABABAB',
                      backgroundColor: '#2E3238',
                    },
                  }}
                />

                {(permission.includes('Emp_Auth') && pages.includes('V3_Volunteer_Signup')) && <Menu.Item
                  to="/firehouse/assignment-requests"
                  primaryText="Assignment Requests"
                  // hidden={permission.includes('Emp_Auth') && pages.includes('V3_Volunteer_Signup') ? false : true}
                  sx={{
                    ...subMenuRowStyles,
                    pl: open ? 6 : 1,
                    '&.RaMenuItemLink-active': {
                      color: '#ABABAB',
                      backgroundColor: '#2E3238',
                    },
                  }}
                />}

                <Menu.Item
                  to="/firehouse/cancelled-assignments"
                  primaryText="Cancelled Assignments"
                  hidden={permission.includes('Emp_Auth') && pages.includes('V3_Volunteer_Signup') ? false : true}
                  sx={{
                    ...subMenuRowStyles,
                    pl: open ? 6 : 1,
                    '&.RaMenuItemLink-active': {
                      color: '#ABABAB',
                      backgroundColor: '#2E3238',
                    },
                  }}
                />

                {(permission.includes('Emp_Auth') || permission.includes('master_user')) && <Menu.Item
                  to="/firehouse/schedule-override"
                  primaryText="Resource Assignment"
                  hidden={!pages.includes('SCHEDULE_SELECT_POSITION_DAY_NIGHT')}
                  sx={{
                    ...subMenuRowStyles,
                    pl: open ? 6 : 1,
                    '&.RaMenuItemLink-active': {
                      color: '#ABABAB',
                      backgroundColor: '#2E3238',
                    },
                  }}
                />}

                {v3Data?.V3_recall_menu && (<Menu.Item
                  to="/firehouse/recall/pages"
                  primaryText="Recall/Pages"
                  hidden={!permission.includes('GR_Auth')}
                  sx={{
                    ...subMenuRowStyles,
                    pl: open ? 6 : 1,
                    '&.RaMenuItemLink-active': {
                      color: '#ABABAB',
                      backgroundColor: '#2E3238',
                    },
                  }}
                />)}

                {v3Data?.V3_recall_menu && (
                  <Menu.Item
                    to="/firehouse/user-recall"
                    primaryText="User Recall"
                    hidden={permission.includes('Emp_Auth') || permission.includes('master_user')}
                    sx={{
                      ...subMenuRowStyles,
                      pl: open ? 6 : 1,
                      '&.RaMenuItemLink-active': {
                        color: '#ABABAB',
                        backgroundColor: '#2E3238',
                      },
                    }}
                  />)}

                {v3Data?.IMPORT_SCHEDULE &&
                  <Menu.Item
                    to="/firehouse/import-schedule"
                    primaryText="Import Schedule"
                    hidden={!permission.includes('Emp_Auth') || !permission.includes('master_user')}
                    sx={{
                      ...menuRowStyles,
                      pl: open ? 6 : 1,
                      '&.RaMenuItemLink-active': {
                        color: '#ABABAB',
                        backgroundColor: '#2E3238',
                      },
                    }}
                  />}

                <Menu.Item
                  to="/firehouse/daily-swap-list"
                  primaryText="Daily Swap List"
                  hidden={!v3Data?.V3_dailyswap_adjustment}
                  sx={{
                    ...subMenuRowStyles,
                    pl: open ? 6 : 1,
                    '&.RaMenuItemLink-active': {
                      color: '#ABABAB',
                      backgroundColor: '#2E3238',
                    },
                  }}
                />
              </Box>
            </Collapse>

            {permission.includes('Emp_Auth') &&
              <Box onClick={() => toggleMenu('memberManagement')} sx={menuRowStyles}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <MemberIcon width="20px" height="20px" />
                  {open && <span style={{ marginLeft: '0.625rem', fontFamily: 'karla, sans-serif', fontSize: '0.9375rem', fontWeight: 600 }}>Personnel</span>}
                </Box>

                {open &&
                  (menuOpen.memberManagement ? (
                    <KeyboardArrowDownIcon />
                  ) : (
                    <KeyboardArrowRightIcon />
                  ))}
              </Box>}

            <Collapse in={menuOpen.memberManagement} timeout={1000} unmountOnExit>
              <Box sx={{ ml: open ? 4 : 0, borderLeft: open ? "2px solid rgba(255,255,255,0.15)" : "none", pl: open ? 1 : 0 }}>
                <Menu.Item
                  to="/firehouse/members"
                  primaryText="Members"
                  hidden={!permission.includes("OT_Auth")}
                  sx={{
                    ...subMenuRowStyles,
                    pl: open ? 6 : 1,
                    '&.RaMenuItemLink-active': {
                      color: '#ABABAB',
                      backgroundColor: '#2E3238',
                    },
                  }}
                />

                {v3Data?.V3_APPROVE_RTO_COUNTER_BADGE ? (<Menu.Item
                  to="/firehouse/approve-shifts"
                  hidden={!containsPartFromArray(permission, "OT_Auth,OT_APPROVE")}
                  sx={{
                    ...subMenuRowStyles,
                    pl: open ? 6 : 1,
                    '&.RaMenuItemLink-active': {
                      color: '#ABABAB',
                      backgroundColor: '#2E3238',
                    },
                  }}
                  primaryText={
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        width: '100%',
                      }}
                    >
                      <span>Approve RTO</span>
                      <MenuBadge count={approveRtoCount} />
                    </Box>
                  }
                />) : (<Menu.Item
                  to="/firehouse/approve-shifts"
                  primaryText="Approve RTO"
                  hidden={!containsPartFromArray(permission, "OT_Auth,OT_APPROVE")}
                  sx={{
                    ...subMenuRowStyles,
                    pl: open ? 6 : 1,
                    '&.RaMenuItemLink-active': {
                      color: '#ABABAB',
                      backgroundColor: '#2E3238',
                    },
                  }}
                />)}

                <Menu.Item
                  to="/firehouse/manage-swap-requests"
                  primaryText="Swap Requests"
                  hidden={!(permission.includes('Emp_Auth') && v3Data?.V3_SHIFT_TRADE_ENABLED == 'true')}
                  sx={{
                    ...subMenuRowStyles,
                    pl: open ? 6 : 1,
                    '&.RaMenuItemLink-active': {
                      color: '#ABABAB',
                      backgroundColor: '#2E3238',
                    },
                  }}
                />


                <Menu.Item
                  to="/firehouse/Lists"
                  primaryText="Lists"
                  sx={{
                    ...subMenuRowStyles,
                    pl: open ? 6 : 1,
                    '&.RaMenuItemLink-active': {
                      color: '#ABABAB',
                      backgroundColor: '#2E3238',
                    },
                  }}
                />

                <Menu.Item
                  to="/firehouse/manage-overtime"
                  primaryText="Manage Overtime"
                  hidden={permission.includes('Emp_Auth') && permission.includes('OT_Auth') ? false : true}
                  sx={{
                    ...subMenuRowStyles,
                    pl: open ? 6 : 1,
                    '&.RaMenuItemLink-active': {
                      color: '#ABABAB',
                      backgroundColor: '#2E3238',
                    },
                  }}
                />

                <Menu.Item
                  to="/firehouse/adjust-hours"
                  primaryText="Adjust Hours"
                  hidden={permission.includes('Emp_Auth') && permission.includes('OT_Auth') ? false : true}
                  sx={{
                    ...subMenuRowStyles,
                    pl: open ? 6 : 1,
                    '&.RaMenuItemLink-active': {
                      color: '#ABABAB',
                      backgroundColor: '#2E3238',
                    },
                  }}
                />

                <Menu.Item
                  to="/firehouse/manage-free-passes"
                  primaryText="Manage Passes"
                  hidden={!v3Data?.V3_ENABLE_MANAGE_OS_PASSES || !containsPartFromArray(permission, "OT_Auth,OT_APPROVE")}
                  sx={{
                    ...subMenuRowStyles,
                    pl: open ? 6 : 1,
                    '&.RaMenuItemLink-active': {
                      color: '#ABABAB',
                      backgroundColor: '#141a24',
                    },
                  }}
                />

                <Menu.Item
                  to="/firehouse/certificates"
                  primaryText="Certificates"
                  hidden={!pages.includes('V3_CERTIFICATE_MODULE') ? true : pages.includes('V3_CERTIFICATE_MODULE') && permission.includes('Emp_Auth') ? false : true}
                  sx={{
                    ...subMenuRowStyles,
                    pl: open ? 6 : 1,
                    '&.RaMenuItemLink-active': {
                      color: '#ABABAB',
                      backgroundColor: '#2E3238',
                    },
                  }}
                />

                <Menu.Item
                  to="/firehouse/recurring-position-assignment"
                  primaryText="Recurring Position Assignment"
                  hidden={!pages.includes('V3_ALLOW_VOLUNTEER_RECURRING_FILL')}
                  sx={{
                    ...subMenuRowStyles,
                    pl: open ? 6 : 1,
                    '&.RaMenuItemLink-active': {
                      color: '#ABABAB',
                      backgroundColor: '#2E3238',
                    },
                  }}
                />
              </Box>
            </Collapse>

            <Box onClick={() => toggleMenu('availability')} sx={menuRowStyles}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <AvailabilityIcon width="20px" height="20px" />
                {open && <span style={{ marginLeft: '0.625rem', fontFamily: 'karla, sans-serif', fontSize: '0.9375rem', fontWeight: 600 }}>Availability</span>}
              </Box>

              {open &&
                (menuOpen.availability ? (
                  <KeyboardArrowDownIcon />
                ) : (
                  <KeyboardArrowRightIcon />
                ))}
            </Box>

            <Collapse in={menuOpen.availability} timeout={1000} unmountOnExit>
              <Box sx={{ ml: open ? 4 : 0, borderLeft: open ? "2px solid rgba(255,255,255,0.15)" : "none", pl: open ? 1 : 0 }}>
                <Menu.Item
                  to="/firehouse/RTO"
                  primaryText="Request RTO"
                  hidden={!pages.includes("MENU_REQ_TIME_OFF")}
                  sx={{
                    ...subMenuRowStyles,
                    pl: open ? 6 : 1,
                    '&.RaMenuItemLink-active': {
                      color: '#ABABAB',
                      backgroundColor: '#2E3238',
                    },
                  }}
                />

                <Menu.Item
                  to="/firehouse/leave-book"
                  primaryText="Leave Book"
                  hidden={!pages.includes('MENU_LEAVE_BOOK')}
                  sx={{
                    ...subMenuRowStyles,
                    pl: open ? 6 : 1,
                    '&.RaMenuItemLink-active': {
                      color: '#ABABAB',
                      backgroundColor: '#2E3238',
                    },
                  }}
                />

                {!permission.includes('Emp_Auth') && 
                <Menu.Item
                  to="/firehouse/Lists"
                  primaryText="Lists"
                  sx={{
                    ...subMenuRowStyles,
                    pl: open ? 6 : 1,
                    '&.RaMenuItemLink-active': {
                      color: '#ABABAB',
                      backgroundColor: '#2E3238',
                    },
                  }}
                />}

                  <Menu.Item
                    to="/firehouse/overtime-signup"
                    primaryText="Overtime Signup"
                    hidden={!pages.includes('V3_OVERTIME_SIGNUP_FORM')}
                    sx={{
                      ...subMenuRowStyles,
                      pl: open ? 6 : 1,
                      '&.RaMenuItemLink-active': {
                        color: '#ABABAB',
                        backgroundColor: '#2E3238',
                      },
                    }}
                  />

                <Menu.Item
                  to="/firehouse/volunteer-signup-new"
                  primaryText={v3Data?.V3_VERBIAGE_VOLUNTEER ? 'Per-diem Signup' : 'Volunteer Signup'}
                  hidden={!pages.includes('V3_Volunteer_Signup')}
                  sx={{
                    ...subMenuRowStyles,
                    pl: open ? 6 : 1,
                    '&.RaMenuItemLink-active': {
                      color: '#ABABAB',
                      backgroundColor: '#2E3238',
                    },
                  }}
                />

                <Menu.Item
                  to="/firehouse/vacation-bids"
                  primaryText="Vacation Bids"
                  hidden={!v3Data?.V3_VACATION_BIDDING || !permission.includes('Emp_Auth')}
                  sx={{
                    ...subMenuRowStyles,
                    pl: open ? 6 : 1,
                    '&.RaMenuItemLink-active': {
                      color: '#ABABAB',
                      backgroundColor: '#2E3238',
                    },
                  }}
                />

                <Menu.Item
                  to="/firehouse/vacation-bid-user"
                  primaryText="My Vacation Bids"
                  hidden={!v3Data?.V3_VACATION_BIDDING}
                  sx={{
                    ...subMenuRowStyles,
                    pl: open ? 6 : 1,
                    '&.RaMenuItemLink-active': {
                      color: '#ABABAB',
                      backgroundColor: '#2E3238',
                    },
                  }}
                />

                <Menu.Item
                  to="/firehouse/view-bids"
                  primaryText="View Bids"
                  hidden={!pages.includes('VIEWBIDS') ? true : pages.includes('VIEWBIDS') && permission.includes('Schedule_Auth') ? false : true}
                  sx={{
                    ...subMenuRowStyles,
                    pl: open ? 6 : 1,
                    '&.RaMenuItemLink-active': {
                      color: '#ABABAB',
                      backgroundColor: '#2E3238',
                    },
                  }}
                />

                {v3Data?.V3_OFF_DUTY_TRAINING_MODULE &&
                  <Menu.Item
                    to="/firehouse/off-duty-training"
                    primaryText="Off Duty Training"
                    sx={{
                      ...menuRowStyles,
                      pl: open ? 6 : 1,
                      '&.RaMenuItemLink-active': {
                        color: '#ABABAB',
                        backgroundColor: '#2E3238',
                      },
                    }}
                  />}

              </Box>
            </Collapse>

            {pages.includes('V3_INVENTORY_MODULE') &&
              <Box onClick={() => toggleMenu('inventory')} sx={menuRowStyles}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <InventoryMenuIcon width="20px" height="20px" />
                  {open && <span style={{ marginLeft: '0.625rem', fontFamily: 'karla, sans-serif', fontSize: '0.9375rem', fontWeight: 600 }}>Inventory</span>}
                </Box>

                {open &&
                  (menuOpen.inventory ? (
                    <KeyboardArrowDownIcon />
                  ) : (
                    <KeyboardArrowRightIcon />
                  ))}
              </Box>}

            <Collapse in={menuOpen.inventory} timeout={1000} unmountOnExit>
              <Box sx={{ ml: open ? 4 : 0, borderLeft: open ? "2px solid rgba(255,255,255,0.15)" : "none", pl: open ? 1 : 0 }}>
                <Menu.Item
                  to="/firehouse/tickets"
                  primaryText="My Tickets"
                  sx={{
                    ...subMenuRowStyles,
                    pl: open ? 6 : 1,
                    '&.RaMenuItemLink-active': {
                      color: '#ABABAB',
                      backgroundColor: '#2E3238',
                    },
                  }}
                />

                {/* <Menu.Item
                  to="#"
                  primaryText="Daily Checklist"
                  sx={{
                    ...subMenuRowStyles,
                    pl: open ? 6 : 1,
                    '&.RaMenuItemLink-active': {
                      color: '#ABABAB',
                      backgroundColor: '#2E3238',
                    },
                  }}
                /> */}

                {/* <Menu.Item
                  to="#"
                  primaryText="Inventory Checklist"
                  sx={{
                    ...subMenuRowStyles,
                    pl: open ? 6 : 1,
                    '&.RaMenuItemLink-active': {
                      color: '#ABABAB',
                      backgroundColor: '#2E3238',
                    },
                  }}
                /> */}

                <Menu.Item
                  to="/firehouse/checklist"
                  primaryText="Checklist Definition"
                  sx={{
                    ...subMenuRowStyles,
                    pl: open ? 6 : 1,
                    '&.RaMenuItemLink-active': {
                      color: '#ABABAB',
                      backgroundColor: '#2E3238',
                    },
                  }}
                  hidden={!permission.includes('Checklist_Auth')}
                />

                <Menu.Item
                  to="/firehouse/station-checklist"
                  primaryText="Station Checklist Def."
                  sx={{
                    ...subMenuRowStyles,
                    pl: open ? 6 : 1,
                    '&.RaMenuItemLink-active': {
                      color: '#ABABAB',
                      backgroundColor: '#2E3238',
                    },
                  }}
                  hidden={!permission.includes('Checklist_Auth') && user?.employee_assignment?.EA_Rank !== 'AC'}
                />

                <Menu.Item
                  to="/firehouse/checklist-chief/data"
                  primaryText="Daily Check View"
                  hidden={!pages.includes('V3_INVENTORY_MODULE') || !permission.includes('Schedule_Auth')}
                  sx={{
                    ...subMenuRowStyles,
                    pl: open ? 6 : 1,
                    '&.RaMenuItemLink-active': {
                      color: '#ABABAB',
                      backgroundColor: '#2E3238',
                    },
                  }}
                />

                <Menu.Item
                  to="/firehouse/my-checklist"
                  primaryText="My Checklist"
                  sx={{
                    ...subMenuRowStyles,
                    pl: open ? 6 : 1,
                    '&.RaMenuItemLink-active': {
                      color: '#ABABAB',
                      backgroundColor: '#2E3238',
                    },
                  }}
                />

                <Menu.Item
                  to="/firehouse/my-station-checklist"
                  primaryText="My Station Checklist"
                  sx={{
                    ...subMenuRowStyles,
                    pl: open ? 6 : 1,
                    '&.RaMenuItemLink-active': {
                      color: '#ABABAB',
                      backgroundColor: '#2E3238',
                    },
                  }}
                />

                <Menu.Item
                  to="/firehouse/attribute-management"
                  primaryText="Attributes"
                  hidden={!permission.includes('Schedule_Auth')}
                  sx={{
                    ...subMenuRowStyles,
                    pl: open ? 6 : 1,
                    '&.RaMenuItemLink-active': {
                      color: '#ABABAB',
                      backgroundColor: '#2E3238',
                    },
                  }}
                />
                <Menu.Item
                  to="/firehouse/inventory"
                  primaryText="Inventory Management"
                  hidden={!permission.includes('Schedule_Auth')}
                  sx={{
                    ...subMenuRowStyles,
                    pl: open ? 6 : 1,
                    '&.RaMenuItemLink-active': {
                      color: '#ABABAB',
                      backgroundColor: '#2E3238',
                    },
                  }}
                />
              </Box>
            </Collapse>

            {pages.includes('V3_NERIS_MODULE') &&
              <Box onClick={() => toggleMenu('NERIS')} sx={menuRowStyles}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <NERISIcon width="20px" height="20px" />
                  {open && <span style={{ marginLeft: '0.625rem', fontFamily: 'karla, sans-serif', fontSize: '0.9375rem', fontWeight: 600 }}>NERIS</span>}
                </Box>

                {open &&
                  (menuOpen.NERIS ? (
                    <KeyboardArrowDownIcon />
                  ) : (
                    <KeyboardArrowRightIcon />
                  ))}
              </Box>}

            <Collapse in={menuOpen.NERIS} timeout={1000} unmountOnExit>
              <Box sx={{ ml: open ? 4 : 0, borderLeft: open ? "2px solid rgba(255,255,255,0.15)" : "none", pl: open ? 1 : 0 }}>
                <Menu.Item
                  to="/firehouse/incidents"
                  primaryText="Incidents"
                  hidden={!pages.includes('V3_NERIS_MODULE')}
                  sx={{
                    ...subMenuRowStyles,
                    pl: open ? 6 : 1,
                    '&.RaMenuItemLink-active': {
                      color: '#ABABAB',
                      backgroundColor: '#2E3238',
                    },
                  }}
                />

                <Menu.Item
                  to="/firehouse/pre-plans"
                  primaryText="Pre-Plans"
                  hidden={!pages.includes('V3_NERIS_MODULE') || !permission.includes('Schedule_Auth')}
                  sx={{
                    ...subMenuRowStyles,
                    pl: open ? 6 : 1,
                    '&.RaMenuItemLink-active': {
                      color: '#ABABAB',
                      backgroundColor: '#2E3238',
                    },
                  }}
                />

                <Menu.Item
                  to="/firehouse/inspections"
                  primaryText="Inspections"
                  hidden={!pages.includes('V3_NERIS_MODULE') || !permission.includes('Schedule_Auth')}
                  sx={{
                    ...subMenuRowStyles,
                    pl: open ? 6 : 1,
                    '&.RaMenuItemLink-active': {
                      color: '#ABABAB',
                      backgroundColor: '#2E3238',
                    },
                  }}
                />

                <Menu.Item
                  to="/firehouse/neris-settings"
                  primaryText="NERIS Settings"
                  hidden={!pages.includes('V3_NERIS_MODULE')}
                  disabled={!permissions.can_edit_settings}
                  sx={{
                    ...subMenuRowStyles,
                    pl: open ? 6 : 1,
                    '&.RaMenuItemLink-active': {
                      color: '#ABABAB',
                      backgroundColor: '#2E3238',
                    },
                  }}
                />
              </Box>
            </Collapse>

            <Box onClick={() => toggleMenu('Payroll')} sx={menuRowStyles}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <PayrollMenuIcon width="20px" height="20px" />
                {open && <span style={{ marginLeft: '0.625rem', fontFamily: 'karla, sans-serif', fontSize: '0.9375rem', fontWeight: 600 }}>Payroll</span>}
              </Box>

              {open &&
                (menuOpen.Payroll ? (
                  <KeyboardArrowDownIcon />
                ) : (
                  <KeyboardArrowRightIcon />
                ))}
            </Box>
            <Collapse in={menuOpen?.Payroll} timeout={1000} unmountOnExit>
              <Box sx={{ ml: open ? 4 : 0, borderLeft: open ? "2px solid rgba(255,255,255,0.15)" : "none", pl: open ? 1 : 0 }}>
                <Menu.Item
                  to="/firehouse/personal-payroll-report"
                  primaryText="Submitted Payroll"
                  hidden={!v3Data?.V3_PERSONAL_PAYROLL_ACK}
                  sx={{
                    ...subMenuRowStyles,
                    pl: open ? 6 : 1,
                    '&.RaMenuItemLink-active': {
                      color: '#ABABAB',
                      backgroundColor: '#2E3238',
                    },
                  }}
                />

                <Menu.Item
                  to="/firehouse/payroll"
                  primaryText="Payroll Management"
                  hidden={!permission.includes('Schedule_Auth')}
                  sx={{
                    ...subMenuRowStyles,
                    pl: open ? 6 : 1,
                    '&.RaMenuItemLink-active': {
                      color: '#ABABAB',
                      backgroundColor: '#2E3238',
                    },
                  }}
                />

                <Menu.Item
                  to="/firehouse/accrual-management"
                  primaryText="Accrual Management"
                  hidden={!permission.includes('Emp_Auth')}
                  sx={{
                    ...subMenuRowStyles,
                    pl: open ? 6 : 1,
                    '&.RaMenuItemLink-active': {
                      color: '#ABABAB',
                      backgroundColor: '#2E3238',
                    },
                  }}
                />

                <Menu.Item
                  to="/firehouse/member-accrual-summary"
                  primaryText="Member Accrual Summary"
                  hidden={!permission.includes('Emp_Auth')}
                  sx={{
                    ...subMenuRowStyles,
                    pl: open ? 6 : 1,
                    '&.RaMenuItemLink-active': {
                      color: '#ABABAB',
                      backgroundColor: '#2E3238',
                    },
                  }}
                />
              </Box>
            </Collapse>

            {(v3Data?.V3_VOLUNTEER_REPORT_VIEW_ALL || (v3Data?.V3_VOLUNTEER_OPEN_SHIFT_REPORT && v3Data?.V3_VOLUNTEER_OPEN_SHIFT_REPORT == 'true') || v3Data?.V3_VOLUNTEER_MEMBER_HOURS_REPORT) &&
              <Box onClick={() => toggleMenu('VolunteerReports')} sx={menuRowStyles}>
                <Box sx={{ display: 'flex', alignItems: 'center' , gap : 1}}>
                  <ReportsMenuIcon width="28px" height="28px" />
                  {open && <span style={{ marginLeft: '0.625rem', fontFamily: 'karla, sans-serif', fontSize: '0.9375rem', fontWeight: 600 }}>Volunteer/Combo Reports</span>}
                </Box>

                {open &&
                  (menuOpen.VolunteerReports ? (
                    <KeyboardArrowDownIcon />
                  ) : (
                    <KeyboardArrowRightIcon />
                  ))}
              </Box>}

            <Collapse in={menuOpen.VolunteerReports} timeout={1000} unmountOnExit>
              <Box sx={{ ml: open ? 4 : 0, borderLeft: open ? "2px solid rgba(255,255,255,0.15)" : "none", pl: open ? 1 : 0 }}>
                <Menu.Item
                  to="/firehouse/volunteer-report"
                  primaryText="Volunteer"
                  hidden={!v3Data?.V3_VOLUNTEER_REPORT_VIEW_ALL}
                  sx={{
                    ...subMenuRowStyles,
                    pl: open ? 6 : 1,
                    '&.RaMenuItemLink-active': {
                      color: '#ABABAB',
                      backgroundColor: '#2E3238',
                    },
                  }}
                />

                <Menu.Item
                  to="/firehouse/volunteer-open-shift"
                  primaryText="Open Shifts"
                  hidden={!(v3Data?.V3_VOLUNTEER_OPEN_SHIFT_REPORT && v3Data?.V3_VOLUNTEER_OPEN_SHIFT_REPORT == 'true')}
                  sx={{
                    ...subMenuRowStyles,
                    pl: open ? 6 : 1,
                    '&.RaMenuItemLink-active': {
                      color: '#ABABAB',
                      backgroundColor: '#2E3238',
                    },
                  }}
                />

                <Menu.Item
                  to="/firehouse/volunteer-member-hours"
                  primaryText="Volunteer Hours"
                  hidden={!v3Data?.V3_VOLUNTEER_MEMBER_HOURS_REPORT}
                  sx={{
                    ...subMenuRowStyles,
                    pl: open ? 6 : 1,
                    '&.RaMenuItemLink-active': {
                      color: '#ABABAB',
                      backgroundColor: '#2E3238',
                    },
                  }}
                />
              </Box>
            </Collapse>

            <Menu.Item
              to="/firehouse/reports"
              sx={{
                ...menuRowStyles,
                height: '2.5rem',
                '&.RaMenuItemLink-active': {
                  color: '#ABABAB',
                  backgroundColor: '#2E3238',
                },
              }}
              hidden={!permission.includes('Schedule_Auth')}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <ReportsMenuIcon width="20px" height="20px" />
                {open && <span style={{ marginLeft: '0.625rem', fontFamily: 'karla, sans-serif', fontSize: '0.9375rem', fontWeight: 600 }}>Reports</span>}
              </Box>
            </Menu.Item>

            <Menu.Item
              to="/firehouse/jake-data-analysis"
              sx={{
                ...menuRowStyles,
                height: '2.5rem',
                '&.RaMenuItemLink-active': {
                  color: '#ABABAB',
                  backgroundColor: '#2E3238',
                },
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <ReportsMenuIcon width="20px" height="20px" />
                {open && <span style={{ marginLeft: '0.625rem', fontFamily: 'karla, sans-serif', fontSize: '0.9375rem', fontWeight: 600 }}>JAKE Data Analysis</span>}
              </Box>
            </Menu.Item>

            {v3Data?.V3_NEW_MESSAGE_MODULE ? (
              <Menu.Item
                to="/firehouse/chats"
                sx={{
                  ...menuRowStyles,
                  height: '2.5rem',
                  '&.RaMenuItemLink-active': {
                    color: '#ABABAB',
                    backgroundColor: '#2E3238',
                  },
                }}
              // hidden={!permission.includes('SMS_Auth')}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <MessageIcon width="20px" height="20px" />
                  {open && <span style={{ marginLeft: '0.625rem', fontFamily: 'karla, sans-serif', fontSize: '0.9375rem', fontWeight: 600 }}>Messages</span>}
                </Box>
              </Menu.Item>
            ) : (
              permission.includes('SMS_Auth') && (
                <>
                  <Box onClick={() => toggleMenu('Messages')} sx={menuRowStyles}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <MessageIcon width="20px" height="20px" />
                      {open && <span style={{ marginLeft: '0.625rem', fontFamily: 'karla, sans-serif', fontSize: '0.9375rem', fontWeight: 600 }}>Messages</span>}
                    </Box>

                    {open &&
                      (menuOpen.Messages ? (
                        <KeyboardArrowDownIcon />
                      ) : (
                        <KeyboardArrowRightIcon />
                      ))}
                  </Box>

                  <Collapse in={menuOpen.Messages} timeout={1000} unmountOnExit>
                    <Box sx={{ ml: open ? 4 : 0, borderLeft: open ? "2px solid rgba(255,255,255,0.15)" : "none", pl: open ? 1 : 0 }}>
                      <Menu.Item
                        to="/firehouse/messaging"
                        primaryText="Messages"
                        sx={{
                          ...subMenuRowStyles,
                          pl: open ? 6 : 1,
                          '&.RaMenuItemLink-active': {
                            color: '#ABABAB',
                            backgroundColor: '#2E3238',
                          },
                        }}
                      />

                      <Menu.Item
                        to="/firehouse/custom-groups"
                        primaryText="Custom Group"
                        sx={{
                          ...subMenuRowStyles,
                          pl: open ? 6 : 1,
                          '&.RaMenuItemLink-active': {
                            color: '#ABABAB',
                            backgroundColor: '#2E3238',
                          },
                        }}
                      />
                    </Box>
                  </Collapse>
                </>
              )
            )}

            {permission.includes('Emp_Auth') &&
              <Box onClick={() => toggleMenu('Settings')} sx={menuRowStyles}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <ConfigIcon width="20px" height="20px" />
                  {open && <span style={{ marginLeft: '0.625rem', fontFamily: 'karla, sans-serif', fontSize: '0.9375rem', fontWeight: 600 }}>Settings</span>}
                </Box>

                {open &&
                  (menuOpen.Settings ? (
                    <KeyboardArrowDownIcon />
                  ) : (
                    <KeyboardArrowRightIcon />
                  ))}
              </Box>}

            <Collapse in={menuOpen.Settings} timeout={1000} unmountOnExit>
              <Box sx={{ ml: open ? 4 : 0, borderLeft: open ? "2px solid rgba(255,255,255,0.15)" : "none", pl: open ? 1 : 0 }}>
                <Menu.Item
                  to="/firehouse/view-log"
                  primaryText="System Log"
                  sx={{
                    ...subMenuRowStyles,
                    pl: open ? 6 : 1,
                    '&.RaMenuItemLink-active': {
                      color: '#ABABAB',
                      backgroundColor: '#2E3238',
                    },
                  }}
                />

                <Menu.Item
                  to="/firehouse/config"
                  primaryText="System Variables"
                  sx={{
                    ...subMenuRowStyles,
                    pl: open ? 6 : 1,
                    '&.RaMenuItemLink-active': {
                      color: '#ABABAB',
                      backgroundColor: '#2E3238',
                    },
                  }}
                  hidden={!permission.includes("global_admin")}
                />

                <Menu.Item
                  to="/firehouse/admin-panel"
                  primaryText="System Tools"
                  sx={{
                    ...subMenuRowStyles,
                    pl: open ? 6 : 1,
                    '&.RaMenuItemLink-active': {
                      color: '#ABABAB',
                      backgroundColor: '#2E3238',
                    },
                  }}
                  hidden={!permission.includes("global_admin")}
                />

                <Menu.Item
                  to="/firehouse/audit-log"
                  primaryText="Journals"
                  sx={{
                    ...subMenuRowStyles,
                    pl: open ? 6 : 1,
                    '&.RaMenuItemLink-active': {
                      color: '#ABABAB',
                      backgroundColor: '#2E3238',
                    },
                  }}
                  hidden={!permission.includes("Schedule_Auth")}
                />

                <Menu.Item
                  to="/firehouse/select-option"
                  primaryText="Static Data"
                  sx={{
                    ...subMenuRowStyles,
                    pl: open ? 6 : 1,
                    '&.RaMenuItemLink-active': {
                      color: '#ABABAB',
                      backgroundColor: '#2E3238',
                    },
                  }}
                  hidden={!permission.includes("global_admin") && 
                    (!v3Data?.V3_ALLOW_SYSTEM_OPTIONS_PAGE || !pages.includes('SystemOptions'))}
                />

                <Menu.Item
                  to="/firehouse/groups-settings"
                  primaryText="Groups"
                  sx={{
                    ...subMenuRowStyles,
                    pl: open ? 6 : 1,
                    '&.RaMenuItemLink-active': {
                      color: '#ABABAB',
                      backgroundColor: '#2E3238',
                    },
                  }}
                  hidden={!permission.includes("global_admin")}
                />

                <Menu.Item
                  sx={{
                    ...subMenuRowStyles,
                    pl: open ? 6 : 1,
                    '&.RaMenuItemLink-active': {
                      color: '#ABABAB',
                      backgroundColor: '#2E3238',
                    },
                  }}
                  to="/firehouse/template/management"
                  primaryText="Templates"
                  hidden={!permission.includes('Schedule_Auth')}
                />

              </Box>
            </Collapse>

            </>)}
          </Box>


          <Box sx={{
            marginTop: '50px'
          }}>
            {/* <Menu.Item
                className={open ? 'py-3 mx-3' : 'py-3 mx-1'}
                sx={{
                  color: 'white',
                  fontFamily: 'Helvetica',
                  borderTop: '1px solid #3A3F45',
                  borderBottom: '1px solid #3A3F45',
                  my: 1,
                  px: 2,

                  '&.RaMenuItemLink-active': {
                    backgroundColor: '#2E3238 !important',
                    color: 'white',
                  },
                }}
                to="/firehouse/adjust-menu"
                primaryText="Adjust Menu"
                leftIcon={<ConfigIcon width="24px" height="24px" />}
              /> */}

            <MenuItemLink
              to="#"
              onClick={(e) => {
                e.preventDefault();
                setOpen(!open);
              }}
              sx={{
                ...menuRowStyles, ...forceWhiteMenuItem,
                height: '2.5rem',
                marginBottom: isMobile ? '' : '85px'
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                {open ? (
                  <>
                    <KeyboardArrowLeftIcon sx={{ fontSize: 20 }} />
                    <span style={{ marginLeft: '10px', color: '#fff' }}>Hide</span>
                  </>
                ) : (
                  <KeyboardArrowRightIcon sx={{ fontSize: 20 }} />
                )}
              </Box>
            </MenuItemLink>
          </Box>
        </Box>

      </Menu>
    </>
  );
};
